import React from "react";
import "../App.css";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { BiMenu, BiX } from "react-icons/bi";
import fin from "../assets/imgTwo/fin.svg";
import bag from "../assets/imgTwo/bag.svg";
import spider from "../assets/imgTwo/spider.svg";
import shop from "../assets/imgTwo/shop.svg";
import cart from "../assets/imgTwo/cart.svg";
import people from "../assets/imgTwo/people.svg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setActiveMobileDropdown(null); 
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const toggleMobileDropdown = (dropdownName) => {
    setActiveMobileDropdown(activeMobileDropdown === dropdownName ? null : dropdownName);
  };

  const navLinks = [
    { name: "Home", path: "/" },
    {
      name: "Products",
      path: "/products",
    },
    {
      name: "Use Cases",
      path: "/use-cases",
      dropdown: [
        {
          name: "Financial Institutions & Employers",
          path: "/usecases/financial-institutions",
          icon: <img
            src={fin}
            alt="financial services" className="mr-2 text-[#07775D] rounded-full bg-[#E6F1E4] p-2" />
        },
        {
          name: "E-Commerce Platforms",
          path: "/usecases/e-commerce",
          icon: <img
            src={cart}
            alt="financial services" className="mr-2 text-[#07775D] rounded-full bg-[#E6F1E4] p-2" />
        },
        {
          name: "Small Businesses",
          path: "/usecases/small-businesses",
          icon: <img
            src={shop}
            alt="financial services" className="mr-2 text-[#07775D] rounded-full bg-[#E6F1E4] p-2" />
        },
        {
          name: "Start-Ups and Fintechs",
          path: "/usecases/startups",
          icon: <img
            src={spider}
            alt="financial services" className="mr-2 text-[#07775D] rounded-full bg-[#E6F1E4] p-2" />
        },
      ]
    },
    {
      name: "Company",
      path: "/company",
      dropdown: [
        {
          name: "About Us",
          path: "/company/aboutus",
          icon: <img
            src={people}
            alt="financial services" className="mr-2 text-[#07775D] rounded-full bg-[#E6F1E4] p-2" />
        },
        {
          name: "Careers",
          path: "/company/careers",
          icon: <img
            src={bag}
            alt="financial services" className="mr-2 text-[#07775D] rounded-full bg-[#E6F1E4] p-2" />
        },
      ]
    },
    {
      name: "Security",
      path: "/security",
    },
    {
      name: "Support",
      path: "/support",
    },
  ];

  return (
    <nav className="bg-white rounded-full shadow-md mb-2 z-50 md:mx-[5em]">
      <div className="container mx-auto flex justify-between px-8 items-center py-3">
        <a href="/" className="text-inherit no-underline mx-auto md:ml-6">
          <svg width="172" height="50" viewBox="0 0 172 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="172" height="50" rx="4" fill="#151413" />
            <path d="M30.116 19.208V35H23.9V32.592C23.4147 33.3387 22.7613 33.9453 21.94 34.412C21.1373 34.8787 20.176 35.112 19.056 35.112C17.2453 35.112 15.8267 34.5053 14.8 33.292C13.792 32.0787 13.288 30.436 13.288 28.364V19.208H19.476V27.58C19.476 28.3267 19.672 28.924 20.064 29.372C20.4747 29.8013 21.016 30.016 21.688 30.016C22.3787 30.016 22.92 29.8013 23.312 29.372C23.704 28.924 23.9 28.3267 23.9 27.58V19.208H30.116ZM43.9834 19.096C45.7941 19.096 47.2034 19.7027 48.2114 20.916C49.2381 22.1293 49.7514 23.772 49.7514 25.844V35H43.5634V26.628C43.5634 25.8813 43.3581 25.2933 42.9474 24.864C42.5554 24.416 42.0234 24.192 41.3514 24.192C40.6608 24.192 40.1194 24.416 39.7274 24.864C39.3354 25.2933 39.1394 25.8813 39.1394 26.628V35H32.9234V19.208H39.1394V21.616C39.6248 20.8693 40.2688 20.2627 41.0714 19.796C41.8928 19.3293 42.8634 19.096 43.9834 19.096ZM55.5829 17.948C54.5002 17.948 53.6322 17.6587 52.9789 17.08C52.3255 16.5013 51.9989 15.7733 51.9989 14.896C51.9989 14 52.3255 13.2627 52.9789 12.684C53.6322 12.0867 54.5002 11.788 55.5829 11.788C56.6469 11.788 57.5055 12.0867 58.1589 12.684C58.8122 13.2627 59.1389 14 59.1389 14.896C59.1389 15.7733 58.8122 16.5013 58.1589 17.08C57.5055 17.6587 56.6469 17.948 55.5829 17.948ZM58.6629 19.208V35H52.4469V19.208H58.6629ZM68.4983 35.196C67.005 35.196 65.6796 34.9533 64.5223 34.468C63.3836 33.9827 62.4783 33.3107 61.8063 32.452C61.1343 31.5933 60.7516 30.6227 60.6583 29.54H66.6223C66.697 30.0067 66.893 30.352 67.2103 30.576C67.5463 30.8 67.9663 30.912 68.4703 30.912C68.7876 30.912 69.0396 30.8467 69.2263 30.716C69.413 30.5667 69.5063 30.3893 69.5063 30.184C69.5063 29.8293 69.3103 29.5773 68.9183 29.428C68.5263 29.2787 67.8636 29.1107 66.9303 28.924C65.7916 28.7 64.849 28.4573 64.1023 28.196C63.3743 27.9347 62.7303 27.4867 62.1703 26.852C61.629 26.2173 61.3583 25.34 61.3583 24.22C61.3583 23.2493 61.6103 22.372 62.1143 21.588C62.637 20.7853 63.4023 20.16 64.4103 19.712C65.4183 19.2453 66.641 19.012 68.0783 19.012C70.2063 19.012 71.8676 19.5347 73.0623 20.58C74.2756 21.6253 75.0036 22.988 75.2463 24.668H69.7303C69.637 24.2387 69.441 23.912 69.1423 23.688C68.8436 23.4453 68.4423 23.324 67.9383 23.324C67.621 23.324 67.3783 23.3893 67.2103 23.52C67.0423 23.632 66.9583 23.8093 66.9583 24.052C66.9583 24.3693 67.1543 24.612 67.5463 24.78C67.9383 24.9293 68.5636 25.088 69.4223 25.256C70.561 25.48 71.5223 25.732 72.3063 26.012C73.0903 26.292 73.7716 26.7773 74.3503 27.468C74.929 28.14 75.2183 29.0733 75.2183 30.268C75.2183 31.2013 74.9476 32.0413 74.4063 32.788C73.865 33.5347 73.081 34.1227 72.0543 34.552C71.0463 34.9813 69.861 35.196 68.4983 35.196ZM101.653 19.208L97.9012 35H90.9012L88.9972 26.096L86.9812 35H79.9812L76.2572 19.208H82.4172L83.7332 28.812L85.7772 19.208H92.4132L94.5692 28.924L95.9132 19.208H101.653ZM106.114 17.948C105.031 17.948 104.163 17.6587 103.51 17.08C102.857 16.5013 102.53 15.7733 102.53 14.896C102.53 14 102.857 13.2627 103.51 12.684C104.163 12.0867 105.031 11.788 106.114 11.788C107.178 11.788 108.037 12.0867 108.69 12.684C109.343 13.2627 109.67 14 109.67 14.896C109.67 15.7733 109.343 16.5013 108.69 17.08C108.037 17.6587 107.178 17.948 106.114 17.948ZM109.194 19.208V35H102.978V19.208H109.194ZM121.83 29.708V35H119.478C115.147 35 112.982 32.844 112.982 28.532V24.388H111.022V19.208H112.982V15.4H119.198V19.208H121.774V24.388H119.198V28.644C119.198 29.0173 119.282 29.288 119.45 29.456C119.636 29.624 119.935 29.708 120.346 29.708H121.83ZM123.357 27.104C123.357 25.4613 123.693 24.0333 124.365 22.82C125.056 21.588 126.008 20.6453 127.221 19.992C128.453 19.3387 129.853 19.012 131.421 19.012C133.474 19.012 135.201 19.5907 136.601 20.748C138.02 21.9053 138.916 23.5107 139.289 25.564H132.709C132.466 24.7427 131.99 24.332 131.281 24.332C130.777 24.332 130.376 24.5653 130.077 25.032C129.797 25.4987 129.657 26.1893 129.657 27.104C129.657 28.0187 129.797 28.7093 130.077 29.176C130.376 29.6427 130.777 29.876 131.281 29.876C131.99 29.876 132.466 29.4653 132.709 28.644H139.289C138.916 30.6973 138.02 32.3027 136.601 33.46C135.201 34.6173 133.474 35.196 131.421 35.196C129.853 35.196 128.453 34.8693 127.221 34.216C126.008 33.5627 125.056 32.6293 124.365 31.416C123.693 30.184 123.357 28.7467 123.357 27.104ZM152.319 19.096C154.13 19.096 155.539 19.7027 156.547 20.916C157.574 22.1293 158.087 23.772 158.087 25.844V35H151.899V26.628C151.899 25.8813 151.694 25.2933 151.283 24.864C150.891 24.416 150.359 24.192 149.687 24.192C148.997 24.192 148.455 24.416 148.063 24.864C147.671 25.2933 147.475 25.8813 147.475 26.628V35H141.259V14.28H147.475V21.616C147.961 20.8693 148.605 20.2627 149.407 19.796C150.229 19.3293 151.199 19.096 152.319 19.096Z" fill="white" />
          </svg>
        </a>
        
        <button
          className="text-3xl md:hidden text-gray-600 focus:outline-none"
          onClick={toggleMenu}
        >
          {isOpen ? <BiX /> : <BiMenu />}
        </button>
        
        <ul className="md:flex space-x-6 hidden font-semibold items-center">
          {navLinks.map((link, index) => (
            <li key={index} className="relative group h-full flex items-center">
              {link.dropdown ? (
                <div className="relative h-full flex items-center">
                  <button
                    onClick={() => toggleDropdown(link.name)}
                    className="text-gray-600 hover:bg-[#E6F1EF] px-3 py-2 rounded transition duration-300 flex items-center h-full"
                  >
                    {link.name}
                    <span className="ml-1">
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${activeDropdown === link.name ? 'transform rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </span>
                  </button>

                  {activeDropdown === link.name && (
                    <div className="absolute left-[-80px] top-16 w-[32rem] border border-green-600 bg-white rounded-2xl shadow-lg py-3 z-50 border border-gray-200">
                      <div className="absolute -top-2 left-[126px] w-4 h-4 bg-white transform rotate-45 border-t border-l border-gray-200"></div>
                      <div className="grid grid-cols-2 gap-8 px-2 z-10 ">
                        {link.dropdown.map((item, idx) => (
                          <Link
                            key={idx}
                            to={item.path}
                            className="block px-1 py-2 text-gray-700 hover:bg-[#E6F1EF] transition duration-200 rounded text-sm space-y-6 flex items-center"
                          >
                            {item.icon}
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to={link.path}
                  className={`text-gray-600 hover:bg-[#E6F1EF] px-3 py-2 rounded transition duration-300 relative h-full flex items-center ${location.pathname === link.path ? 'text-[#07775D]' : ''
                    }`}
                >
                  {link.name}
                  <span className={`absolute left-0 right-0 mx-auto bottom-0 h-[3px] bg-[#07775D] transition-all duration-300 ${location.pathname === link.path ? 'w-full' : 'w-0'
                    }`}></span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      {isOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white rounded-2xl shadow-lg mt-2 mx-4 py-4 z-50 border border-gray-200">
          <ul className="space-y-2 px-6">
            {navLinks.map((link, index) => (
              <li key={index}>
                {link.dropdown ? (
                  <div>
                    <button
                      onClick={() => toggleMobileDropdown(link.name)}
                      className={`w-full text-left px-4 py-3 text-gray-600 hover:bg-[#E6F1EF] rounded-lg transition duration-300 flex items-center justify-between font-semibold ${location.pathname === link.path ? 'text-[#07775D] bg-[#E6F1EF]' : ''
                        }`}
                    >
                      {link.name}
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${activeMobileDropdown === link.name ? 'transform rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    
                    {activeMobileDropdown === link.name && (
                      <div className="mt-2 ml-4 space-y-1">
                        {link.dropdown.map((item, idx) => (
                          <Link
                            key={idx}
                            to={item.path}
                            onClick={toggleMenu}
                            className="block px-4 py-2 text-gray-600 hover:bg-[#E6F1EF] rounded-lg transition duration-200 text-sm flex items-center"
                          >
                            {item.icon}
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={link.path}
                    onClick={toggleMenu}
                    className={`block px-4 py-3 text-gray-600 hover:bg-[#E6F1EF] rounded-lg transition duration-300 font-semibold ${location.pathname === link.path ? 'text-[#07775D] bg-[#E6F1EF]' : ''
                      }`}
                  >
                    {link.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;